export function prettyFormatTimestamp(
  timeStamp: Date,
  locale: string = ''
): string {
  if (timeStamp === null) {
    return '';
  }

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  };

  const newDate = timeStamp.toLocaleString(locale, options);

  return newDate;
}
